// ADD NEW FLAGS HERE
// make sure value is server value!
export const EXPERIMENT_FLAGS = {
  suggestionsFeed: "SuggestionsFeed",
  weekInReviewOnProfile: "WeekInReviewOnProfile",
  workForecasting: "WorkForecasting",
  disableHealthChecks: "DisableHealthChecks",
  showLogs: "ShowLogs",
  doNotDefaultEnableFocusTimeSync: "DoNotDefaultEnableFocusTimeSync",
  ignoreOnboardingFinishedToInviteHack: "IgnoreOnboardingFinishedToInviteHack",
  personalizedInviteLinks: "PersonalizedInviteLinks",
  inlineReschedule: "InlineReschedule",
  fullyInlineReschedule: "FullyInlineReschedule",
  supportEngineerInterviewFrontEndBug: "SupportEngineerInterviewFrontEndBug",
  conflictResolution: "ConflictResolution",
  focusTimeReminders: "FocusTimeReminders",
  advancedUserLogging: "AdvancedUserLogging",
  superchargedNUX: "SuperchargedNUX",
  calendarEventModal: "CalendarEventModal",
  draggableWorkingHours: "DraggableWorkingHours",
  onboardingInternal: "OnboardingInternal",
  trackLogging: "TrackLogging",
  onboardingDraggableWorkingHours: "OnboardingDraggableWorkingHours",
  triggerDefrag: "TriggerDefrag",
  toolTipDebugging: "ToolTipDebugging",
  recurringEventScheduling: "RecurringEventScheduling",
  slackDogfoodApp: "SlackDogfoodApp",
  oneOnOneCoverage: "OneOnOneCoverage",
  inlineSchedulingSuggestions: "InlineSchedulingSuggestions",
  createEventAutopick: "CreateEventAutopick",
  heatmap: "Heatmap",
  linkSchedulerCopyTimes: "LinkSchedulerCopyTimes",
  linkScheduler: "LinkScheduler",
  checkoutPageTeamsDefault: "CheckoutPageTeamsDefault",
  onboardingFocusTimeSyncAndLunchStep: "OnboardingFocusTimeSyncAndLunchStep",
  onboardingScheduleTestEvent: "OnboardingScheduleTestEvent",
  managerSegmentedOnboarding: "ManagerSegmentedOnboarding",
  webSettings: "WebSettings",
  reduceMinSeatCountTo1: "ReduceMinSeatCountTo1",
} as const;

export type ExperimentNameType = typeof EXPERIMENT_FLAGS[keyof typeof EXPERIMENT_FLAGS];
export type ExperimentMappingType = {
  [key in ExperimentNameType]: boolean;
};

// Dont use if possible. Exists just for InlineReschedule. Will delete in a couple weeks
// once we can update the chrome extension and get majority of users on newest version.
export const experimentsHardcodedOn = ["InlineReschedule"] as ExperimentNameType[];
